import qs from "qs";

import { axiosWithAuth } from "helpers";
import { getTerminalSolutionBody } from "mappers";
import { TerminalSolutionCreateDto, TerminalSolutionEditDto } from "types/api";

export const merchantTerminalService = {
	addTerminalSolution,
	ariseMerchantBoarding,
	copyTerminalSolution,
	createTsysStageOnlyVar,
	getTerminalList,
	getTerminalSolutionById,
	updateTerminalSolution,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getTerminalList({ page, sortBy, filters, merchantId }) {
	const body = getTerminalSolutionBody({
		page,
		filters,
		sortBy,
		PAGE_SIZE,
	});

	const options = {
		method: "GET",
		params: body,
		url: `${API_URL}/api/merchants/${merchantId}/terminal_solutions`,
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
	};

	return axiosWithAuth(options);
}

function updateTerminalSolution(
	terminalId,
	merchant_id,
	data: TerminalSolutionEditDto,
) {
	const options = {
		method: "PUT",
		url: `${API_URL}/api/merchants/${merchant_id}/terminal_solutions/${terminalId}`,
		data: JSON.stringify(data),
	};
	return axiosWithAuth(options);
}

function getTerminalSolutionById(id, merchantId) {
	const options = {
		url: `${API_URL}/api/merchants/${merchantId}/terminal_solutions/${id}`,
	};
	return axiosWithAuth(options);
}

function addTerminalSolution(data: TerminalSolutionCreateDto) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/merchants/${data.merchant_id}/terminal_solutions`,
		data: JSON.stringify(data),
	};
	return axiosWithAuth(options);
}

function copyTerminalSolution(terminalId, merchantId) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/merchants/${merchantId}/terminal_solutions/${terminalId}/copy`,
	};
	return axiosWithAuth(options);
}

function createTsysStageOnlyVar({ merchantId, terminalId }) {
	const terminalUrl = `/api/merchants/${merchantId}/terminal_solutions/${terminalId}/integrate_with_tsys`;
	const options = {
		method: "POST",
		url: `${API_URL}${terminalUrl}`,
	};

	return axiosWithAuth(options);
}

function ariseMerchantBoarding(merchantId) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/arise/merchants/create_from_merchant/${merchantId}`,
	};
	return axiosWithAuth(options);
}
